// import React, { useState } from 'react';
// import { Formik, Form, Field } from 'formik';
// import * as Yup from 'yup';
// import {
//   User, CreditCard, Save, Loader2, Lock, ChevronRight, ShieldCheck, Zap, ExternalLink
// } from 'lucide-react';
// import { motion, AnimatePresence } from 'framer-motion';
// import toast from 'react-hot-toast';
// import { authAPI, billingAPI } from '../../services/api'; // Import billingAPI
// import { useAuth } from '../../context/AuthContext';
// import Button from '../../components/ui/Button';
// import SEO from '../../components/shared/SEO';

// const tabs = [
//   { id: 'profile', label: 'My Profile', icon: User },
//   { id: 'billing', label: 'Billing', icon: CreditCard },
// ];

// export default function Settings() {
//   const [activeTab, setActiveTab] = useState('profile');
//   const [billingLoading, setBillingLoading] = useState(false);
//   const { user, setUser } = useAuth();

//   // --- Dynamic Billing Handler ---
//   const handleBillingAction = async () => {
//     setBillingLoading(true);
//     try {
//       let response;
//       if (user?.subscriptionStatus === 'active') {
//         // If active -> Open Customer Portal (Update card, cancel, history)
//         response = await billingAPI.createPortalSession();
//       } else {
//         // If trial/expired -> Open Checkout (Buy Subscription)
//         response = await billingAPI.createCheckoutSession();
//       }
      
//       // Redirect to Stripe
//       if (response?.url) window.location.href = response.url;
      
//     } catch (err) {
//       console.error(err);
//       setBillingLoading(false);
//       // Toast is handled by global interceptor in api.js
//     }
//   };

//   const isPro = user?.subscriptionStatus === 'active';

//   return (
//     <>
//       <SEO title="Settings | EnvDock" description="Manage your account." noIndex={true} />
//       <div className="max-w-6xl mx-auto space-y-10">

//         {/* --- Page Header --- */}
//         <div className="flex flex-col md:flex-row md:items-end justify-between gap-6">
//           <div>
//             <h1 className="text-4xl font-black text-white tracking-tighter">Account Settings</h1>
//             <p className="text-gray-500 font-medium mt-1">Manage your identity and subscription preferences.</p>
//           </div>
//         </div>

//         <div className="flex flex-col lg:flex-row gap-12">

//           {/* --- LEFT SIDEBAR NAVIGATION --- */}
//           <div className="w-full lg:w-64 shrink-0">
//             <nav className="sticky top-24 space-y-1">
//               {tabs.map((tab) => {
//                 const Icon = tab.icon;
//                 const isActive = activeTab === tab.id;
//                 return (
//                   <button
//                     key={tab.id}
//                     onClick={() => setActiveTab(tab.id)}
//                     className={`w-full group flex items-center justify-between px-4 py-3.5 rounded-xl transition-all duration-300 ${isActive
//                       ? 'bg-orange-500/10 text-orange-500 border border-orange-500/20 shadow-lg shadow-orange-500/5'
//                       : 'text-gray-500 hover:text-white hover:bg-white/5 border border-transparent'
//                       }`}
//                   >
//                     <div className="flex items-center gap-3">
//                       <Icon size={18} className={isActive ? 'text-orange-500' : 'group-hover:scale-110 transition-transform'} />
//                       <span className="text-sm font-bold tracking-tight">{tab.label}</span>
//                     </div>
//                     {isActive && <ChevronRight size={14} />}
//                   </button>
//                 );
//               })}
//             </nav>
//           </div>

//           {/* --- RIGHT CONTENT AREA --- */}
//           <div className="flex-1 min-w-0">
//             <AnimatePresence mode="wait">
              
//               {/* --- PROFILE TAB --- */}
//               {activeTab === 'profile' && (
//                 <motion.div
//                   key="profile"
//                   initial={{ opacity: 0, y: 10 }}
//                   animate={{ opacity: 1, y: 0 }}
//                   exit={{ opacity: 0, y: -10 }}
//                   className="space-y-8"
//                 >
//                   {/* Header Profile Card */}
//                   <div className="bg-[#0a0a0a] border border-white/5 rounded-[2rem] p-8 flex flex-col md:flex-row items-center gap-8 relative overflow-hidden">
//                     <div className="absolute top-0 right-0 w-32 h-32 bg-orange-500/5 blur-3xl rounded-full" />

//                     <div className="w-24 h-24 rounded-[2rem] bg-gradient-to-br from-orange-500 to-red-600 p-1 shrink-0 shadow-2xl shadow-orange-500/20 group cursor-pointer relative overflow-hidden">
//                       <div className="w-full h-full bg-[#0a0a0a] rounded-[1.8rem] flex items-center justify-center text-3xl font-black text-white">
//                         {user?.name ? user.name.charAt(0).toUpperCase() : 'U'}
//                       </div>
//                     </div>

//                     <div className="text-center md:text-left">
//                       <div className="flex flex-col md:flex-row md:items-center gap-3 mb-2">
//                         <h2 className="text-2xl font-black text-white tracking-tight">{user?.name}</h2>
//                         <span className="inline-flex items-center gap-1.5 bg-orange-500/10 text-orange-500 text-[10px] px-3 py-1 rounded-full border border-orange-500/20 uppercase font-black tracking-widest">
//                           <ShieldCheck size={12} /> {user?.role || 'Organization Owner'}
//                         </span>
//                       </div>
//                       <p className="text-gray-500 font-medium">{user?.email}</p>
//                     </div>
//                   </div>

//                   {/* Personal Information Form */}
//                   <div className="bg-[#0a0a0a] border border-white/5 rounded-[2rem] p-8">
//                     <h3 className="text-lg font-black text-white tracking-tight mb-6 flex items-center gap-3">
//                       <div className="w-1.5 h-5 bg-orange-500 rounded-full" />
//                       Personal Information
//                     </h3>

//                     <Formik
//                       enableReinitialize
//                       initialValues={{ name: user?.name || '' }}
//                       validationSchema={Yup.object({ name: Yup.string().required('Required') })}
//                       onSubmit={async (values, { setSubmitting }) => {
//                         try {
//                           const updatedUser = await authAPI.updateProfile({ name: values.name });
//                           setUser(updatedUser);
//                           toast.success("Identity updated securely");
//                         } catch (error) {
//                           toast.error("Failed to update profile");
//                         } finally {
//                           setSubmitting(false);
//                         }
//                       }}
//                     >
//                       {({ isSubmitting }) => (
//                         <Form className="space-y-6 max-w-xl">
//                           <div className="group">
//                             <label className="block text-[10px] font-black uppercase tracking-[0.2em] text-gray-500 mb-2 ml-1 group-focus-within:text-orange-500 transition-colors">Display Name</label>
//                             <Field
//                               name="name"
//                               className="w-full bg-white/[0.03] border border-white/10 rounded-xl px-4 py-3 text-sm text-white focus:border-orange-500 focus:ring-4 focus:ring-orange-500/10 outline-none transition-all"
//                             />
//                           </div>
//                           <Button type="submit" disabled={isSubmitting} variant="outline" size="sm">
//                             {isSubmitting ? <Loader2 size={16} className="animate-spin" /> : <Save size={16} className="mr-2" />}
//                             Save Changes
//                           </Button>
//                         </Form>
//                       )}
//                     </Formik>
//                   </div>

//                   {/* Security Section */}
//                   <div className="bg-[#0a0a0a] border border-white/5 rounded-[2rem] p-8">
//                     <h3 className="text-lg font-black text-white tracking-tight mb-6 flex items-center gap-3">
//                       <div className="w-1.5 h-5 bg-red-600 rounded-full" />
//                       Security Credentials
//                     </h3>

//                     <Formik
//                       initialValues={{ currentPassword: '', newPassword: '', confirmPassword: '' }}
//                       validationSchema={Yup.object({
//                         currentPassword: Yup.string().required('Required'),
//                         newPassword: Yup.string().min(8, 'Min 8 chars').required('Required'),
//                         confirmPassword: Yup.string()
//                           .oneOf([Yup.ref('newPassword'), null], 'Passwords must match')
//                           .required('Required')
//                       })}
//                       onSubmit={async (values, { setSubmitting, resetForm }) => {
//                         try {
//                           await authAPI.updatePassword({
//                             currentPassword: values.currentPassword,
//                             newPassword: values.newPassword
//                           });
//                           toast.success("Password rotation successful");
//                           resetForm();
//                         } catch (error) {
//                           toast.error(error.response?.data?.message || "Failed to change password");
//                         } finally {
//                           setSubmitting(false);
//                         }
//                       }}
//                     >
//                       {({ isSubmitting, errors, touched }) => (
//                         <Form className="space-y-6 max-w-xl">
//                           <div className="group">
//                             <label className="block text-[10px] font-black uppercase tracking-[0.2em] text-gray-500 mb-2 ml-1 group-focus-within:text-orange-500 transition-colors">Current Vault Password</label>
//                             <Field
//                               type="password"
//                               name="currentPassword"
//                               className="w-full bg-white/[0.03] border border-white/10 rounded-xl px-4 py-3 text-sm text-white focus:border-orange-500 focus:ring-4 focus:ring-orange-500/10 outline-none transition-all"
//                             />
//                             {errors.currentPassword && touched.currentPassword && <div className="text-red-500 text-[10px] font-bold mt-2 ml-1 uppercase">{errors.currentPassword}</div>}
//                           </div>

//                           <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
//                             <div className="group">
//                               <label className="block text-[10px] font-black uppercase tracking-[0.2em] text-gray-500 mb-2 ml-1">New Password</label>
//                               <Field
//                                 type="password"
//                                 name="newPassword"
//                                 className="w-full bg-white/[0.03] border border-white/10 rounded-xl px-4 py-3 text-sm text-white focus:border-orange-500 focus:ring-4 focus:ring-orange-500/10 outline-none transition-all"
//                               />
//                               {errors.newPassword && touched.newPassword && <div className="text-red-500 text-[10px] font-bold mt-2 ml-1 uppercase">{errors.newPassword}</div>}
//                             </div>
//                             <div className="group">
//                               <label className="block text-[10px] font-black uppercase tracking-[0.2em] text-gray-500 mb-2 ml-1">Confirm New Password</label>
//                               <Field
//                                 type="password"
//                                 name="confirmPassword"
//                                 className="w-full bg-white/[0.03] border border-white/10 rounded-xl px-4 py-3 text-sm text-white focus:border-orange-500 focus:ring-4 focus:ring-orange-500/10 outline-none transition-all"
//                               />
//                               {errors.confirmPassword && touched.confirmPassword && <div className="text-red-500 text-[10px] font-bold mt-2 ml-1 uppercase">{errors.confirmPassword}</div>}
//                             </div>
//                           </div>

//                           <Button type="submit" disabled={isSubmitting} variant="primary" size="sm">
//                             {isSubmitting ? <Loader2 size={16} className="animate-spin" /> : "Update Credentials"}
//                           </Button>
//                         </Form>
//                       )}
//                     </Formik>
//                   </div>
//                 </motion.div>
//               )}

//               {/* --- BILLING TAB (UPDATED) --- */}
//               {activeTab === 'billing' && (
//                 <motion.div
//                   key="billing"
//                   initial={{ opacity: 0, y: 10 }}
//                   animate={{ opacity: 1, y: 0 }}
//                   exit={{ opacity: 0, y: -10 }}
//                   className="space-y-8"
//                 >
//                   {/* Dynamic Billing Hero */}
//                   <div className={`
//                     relative overflow-hidden rounded-[2.5rem] p-10 border transition-colors duration-500
//                     ${isPro ? 'bg-gradient-to-br from-[#0a0a0a] to-[#0a1a0f] border-green-500/20' : 'bg-gradient-to-br from-[#0a0a0a] to-[#1a0a0a] border-orange-500/20'}
//                   `}>
//                     {/* Background Glow */}
//                     <div className={`absolute -top-10 -right-10 w-64 h-64 blur-[100px] rounded-full opacity-20 ${isPro ? 'bg-green-500' : 'bg-orange-500'}`} />

//                     <div className="flex flex-col md:flex-row md:items-center justify-between gap-8 relative z-10">
//                       <div>
//                         <div className="flex items-center gap-3 mb-4">
//                           <span className={`text-[10px] px-3 py-1 rounded-full font-black tracking-widest uppercase ${
//                             isPro ? 'bg-green-500/20 text-green-500' : 'bg-orange-500/20 text-orange-500'
//                           }`}>
//                             {isPro ? 'Pro Tier' : 'Free Trial'}
//                           </span>
                          
//                           {isPro && (
//                              <div className="flex items-center gap-1 text-green-500 text-[10px] font-black uppercase tracking-widest">
//                                <div className="w-1.5 h-1.5 rounded-full bg-green-500 animate-pulse" /> Active
//                              </div>
//                           )}
//                         </div>

//                         <h2 className="text-4xl font-black text-white tracking-tighter mb-2">
//                           {isPro ? 'EnvDock Pro' : 'Trial Access'}
//                         </h2>
//                         <p className="text-gray-500 font-medium max-w-sm">
//                           {isPro 
//                             ? "You have full access to all the features." 
//                             : "You are currently on the 90-day evaluation period."}
//                         </p>
//                       </div>

//                       {/* Pricing Display */}
//                       <div className="text-left md:text-right bg-white/[0.03] border border-white/5 p-6 rounded-3xl backdrop-blur-sm">
//                         <p className="text-4xl font-black text-white tracking-tighter">
//                           $5<span className="text-lg text-gray-600 font-bold tracking-normal">/mo</span>
//                         </p>
//                         <p className="text-[10px] font-black text-gray-500 uppercase tracking-widest mt-1">
//                           Simple Flat Rate
//                         </p>
//                       </div>
//                     </div>

//                     {/* Action Buttons */}
//                    {isPro &&  <div className="mt-10 pt-10 border-t border-white/5 flex flex-wrap gap-4 relative z-10">
//                       <Button 
//                         variant={isPro ? "secondary" : "primary"} 
//                         size="sm"
//                         onClick={handleBillingAction}
//                         disabled={billingLoading}
//                       >
//                         {billingLoading ? (
//                            <Loader2 size={16} className="animate-spin" />
//                         ) : isPro && (
//                            <CreditCard size={16} className="mr-2" />
//                         ) }
//                         {isPro && 'Manage Subscription or view invoices' }
//                       </Button>
                      
//                     </div>}
//                   </div>

//                 </motion.div>
//               )}
//             </AnimatePresence>
//           </div>
//         </div>
//       </div> 
//     </>
//   );
// }



import React, { useState } from 'react';
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';
import {
  User, CreditCard, Save, Loader2, Lock, ChevronRight, ShieldCheck, Zap, ExternalLink
} from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import toast from 'react-hot-toast';
import { authAPI, billingAPI } from '../../services/api'; // Import billingAPI
import { useAuth } from '../../context/AuthContext';
import Button from '../../components/ui/Button';
import SEO from '../../components/shared/SEO';

export default function Settings() {
  const { user, setUser } = useAuth();

  return (
    <>
      <SEO title="Settings | EnvDock" description="Manage your account." noIndex={true} />
      <div className="max-w-6xl mx-auto space-y-10">

        {/* --- Page Header --- */}
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6">
          <div>
            <h1 className="text-4xl font-black text-white tracking-tighter">Account Settings</h1>
            <p className="text-gray-500 font-medium mt-1">Manage your identity.</p>
          </div>
        </div>

          {/* --- RIGHT CONTENT AREA --- */}
          <div className="flex-1 min-w-0">
            <AnimatePresence mode="wait">
                <motion.div
                  key="profile"
                  initial={{ opacity: 0, y: 10 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: -10 }}
                  className="space-y-8"
                >
                  {/* Header Profile Card */}
                  <div className="bg-[#0a0a0a] border border-white/5 rounded-[2rem] p-8 flex flex-col md:flex-row items-center gap-8 relative overflow-hidden">
                    <div className="absolute top-0 right-0 w-32 h-32 bg-orange-500/5 blur-3xl rounded-full" />

                    <div className="w-24 h-24 rounded-[2rem] bg-gradient-to-br from-orange-500 to-red-600 p-1 shrink-0 shadow-2xl shadow-orange-500/20 group cursor-pointer relative overflow-hidden">
                      <div className="w-full h-full bg-[#0a0a0a] rounded-[1.8rem] flex items-center justify-center text-3xl font-black text-white">
                        {user?.name ? user.name.charAt(0).toUpperCase() : 'U'}
                      </div>
                    </div>

                    <div className="text-center md:text-left">
                      <div className="flex flex-col md:flex-row md:items-center gap-3 mb-2">
                        <h2 className="text-2xl font-black text-white tracking-tight">{user?.name}</h2>
                        <span className="inline-flex items-center gap-1.5 bg-orange-500/10 text-orange-500 text-[10px] px-3 py-1 rounded-full border border-orange-500/20 uppercase font-black tracking-widest">
                          <ShieldCheck size={12} /> {user?.role || 'Organization Owner'}
                        </span>
                      </div>
                      <p className="text-gray-500 font-medium">{user?.email}</p>
                    </div>
                  </div>

                  {/* Personal Information Form */}
                  <div className="bg-[#0a0a0a] border border-white/5 rounded-[2rem] p-8">
                    <h3 className="text-lg font-black text-white tracking-tight mb-6 flex items-center gap-3">
                      <div className="w-1.5 h-5 bg-orange-500 rounded-full" />
                      Personal Information
                    </h3>

                    <Formik
                      enableReinitialize
                      initialValues={{ name: user?.name || '' }}
                      validationSchema={Yup.object({ name: Yup.string().required('Required') })}
                      onSubmit={async (values, { setSubmitting }) => {
                        try {
                          const updatedUser = await authAPI.updateProfile({ name: values.name });
                          setUser(updatedUser);
                          toast.success("Identity updated securely");
                        } catch (error) {
                          toast.error("Failed to update profile");
                        } finally {
                          setSubmitting(false);
                        }
                      }}
                    >
                      {({ isSubmitting }) => (
                        <Form className="space-y-6 max-w-xl">
                          <div className="group">
                            <label className="block text-[10px] font-black uppercase tracking-[0.2em] text-gray-500 mb-2 ml-1 group-focus-within:text-orange-500 transition-colors">Display Name</label>
                            <Field
                              name="name"
                              className="w-full bg-white/[0.03] border border-white/10 rounded-xl px-4 py-3 text-sm text-white focus:border-orange-500 focus:ring-4 focus:ring-orange-500/10 outline-none transition-all"
                            />
                          </div>
                          <Button type="submit" disabled={isSubmitting} variant="outline" size="sm">
                            {isSubmitting ? <Loader2 size={16} className="animate-spin" /> : <Save size={16} className="mr-2" />}
                            Save Changes
                          </Button>
                        </Form>
                      )}
                    </Formik>
                  </div>

                  {/* Security Section */}
                  <div className="bg-[#0a0a0a] border border-white/5 rounded-[2rem] p-8">
                    <h3 className="text-lg font-black text-white tracking-tight mb-6 flex items-center gap-3">
                      <div className="w-1.5 h-5 bg-red-600 rounded-full" />
                      Security Credentials
                    </h3>

                    <Formik
                      initialValues={{ currentPassword: '', newPassword: '', confirmPassword: '' }}
                      validationSchema={Yup.object({
                        currentPassword: Yup.string().required('Required'),
                        newPassword: Yup.string().min(8, 'Min 8 chars').required('Required'),
                        confirmPassword: Yup.string()
                          .oneOf([Yup.ref('newPassword'), null], 'Passwords must match')
                          .required('Required')
                      })}
                      onSubmit={async (values, { setSubmitting, resetForm }) => {
                        try {
                          await authAPI.updatePassword({
                            currentPassword: values.currentPassword,
                            newPassword: values.newPassword
                          });
                          toast.success("Password rotation successful");
                          resetForm();
                        } catch (error) {
                          toast.error(error.response?.data?.message || "Failed to change password");
                        } finally {
                          setSubmitting(false);
                        }
                      }}
                    >
                      {({ isSubmitting, errors, touched }) => (
                        <Form className="space-y-6 max-w-xl">
                          <div className="group">
                            <label className="block text-[10px] font-black uppercase tracking-[0.2em] text-gray-500 mb-2 ml-1 group-focus-within:text-orange-500 transition-colors">Current Vault Password</label>
                            <Field
                              type="password"
                              name="currentPassword"
                              className="w-full bg-white/[0.03] border border-white/10 rounded-xl px-4 py-3 text-sm text-white focus:border-orange-500 focus:ring-4 focus:ring-orange-500/10 outline-none transition-all"
                            />
                            {errors.currentPassword && touched.currentPassword && <div className="text-red-500 text-[10px] font-bold mt-2 ml-1 uppercase">{errors.currentPassword}</div>}
                          </div>

                          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                            <div className="group">
                              <label className="block text-[10px] font-black uppercase tracking-[0.2em] text-gray-500 mb-2 ml-1">New Password</label>
                              <Field
                                type="password"
                                name="newPassword"
                                className="w-full bg-white/[0.03] border border-white/10 rounded-xl px-4 py-3 text-sm text-white focus:border-orange-500 focus:ring-4 focus:ring-orange-500/10 outline-none transition-all"
                              />
                              {errors.newPassword && touched.newPassword && <div className="text-red-500 text-[10px] font-bold mt-2 ml-1 uppercase">{errors.newPassword}</div>}
                            </div>
                            <div className="group">
                              <label className="block text-[10px] font-black uppercase tracking-[0.2em] text-gray-500 mb-2 ml-1">Confirm New Password</label>
                              <Field
                                type="password"
                                name="confirmPassword"
                                className="w-full bg-white/[0.03] border border-white/10 rounded-xl px-4 py-3 text-sm text-white focus:border-orange-500 focus:ring-4 focus:ring-orange-500/10 outline-none transition-all"
                              />
                              {errors.confirmPassword && touched.confirmPassword && <div className="text-red-500 text-[10px] font-bold mt-2 ml-1 uppercase">{errors.confirmPassword}</div>}
                            </div>
                          </div>

                          <Button type="submit" disabled={isSubmitting} variant="primary" size="sm">
                            {isSubmitting ? <Loader2 size={16} className="animate-spin" /> : "Update Credentials"}
                          </Button>
                        </Form>
                      )}
                    </Formik>
                  </div>
                </motion.div>
            </AnimatePresence>
          </div>
     
      </div> 
    </>
  );
}
